import { getNotifications } from '../../features/notificationSlice';
import { NotificationType } from '../../utils/Types';
import { isAPISuccess } from '../../utils/Util';

export const fetchNotifications = (
  currentNotifications: NotificationType[],
  currentPage: number,
  currentHasMore: boolean,
  isInitialFetch: boolean,
  extraInfo: any
) => {
  const {
    loading,
    setLoading,
    dispatch,
    countPerPage,
    selectedType,
    setNotifications,
    setHasMore,
    setPage,
  } = extraInfo;
  if (!currentHasMore || loading || (!isInitialFetch && currentPage === 1))
    return;

  setLoading(true);

  dispatch(
    getNotifications({
      pageNumber: isInitialFetch ? 1 : currentPage,
      pagePerCount: countPerPage,
      module: selectedType.value,
    })
  )?.then((fulfilled: any) => {
    setLoading(false);
    if (isAPISuccess(fulfilled.payload)) {
      const newNotifications = fulfilled.payload.result ?? [];
      setNotifications((prev: any) =>
        isInitialFetch ? newNotifications : [...prev, ...newNotifications]
      );

      if (
        newNotifications.length < countPerPage ||
        fulfilled.payload.pagination.totalItems <=
          currentNotifications.length + newNotifications.length
      ) {
        setHasMore(false);
      } else {
        setPage((prev: any) => (isInitialFetch ? 2 : prev + 1));
      }
    }
  });
};
